<template>
  <Registro :class="'fundo ' + classe"  paddingSemCheckBox>
    <Cabecalho :titulo="'Alíquota Efetiva Selecionada'" :aliquota="aliquotaEfetivaSelecionada"/>
    <div v-if="!aliquotaEfetivaSelecionada" class="sem-selecao">
       <i class="fa fa-exclamation-triangle" />
       <p> É necessário selecionar uma alíquota para que a Alíquota Efetiva Selecionada seja calculada.</p>
    </div>
  </Registro>
</template>

<script>
import Cabecalho from '@/components/Cabecalho/Cabecalho.vue'
import Registro from '@/components/Registro/Registro.vue'
export default {
  name: 'CalculoFundo',

  props: {
    aliquotaEfetivaSelecionada: String | Number,
    classe: String,
    selecionouFundo: Boolean,
  },

  components: {
    Cabecalho,
    Registro
  },

  // inject:['aliquotaEfetivaSelecionada'],

  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>

<style lang="scss" scoped>
.fundo {
  margin-top: 1rem;
}

.sem-selecao {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  color: var(--importacao);

  p {
    margin-bottom: 0;
  }
}
@media only print {
  .fundo {
  margin-top: -1px;
}

}

</style>